import React from 'react';
import { cn } from '@bem-react/classname';
import { BaseIcon } from './Header-Icons';
import './Mirror-Icon.css';
var cnMirrorIcon = cn('MirrorIcon');
/**
 * Иконка сервиса «Зеркало»
 * @param {IconProps} props
 *
 */
export var MirrorIcon = function (_a) {
    var className = _a.className;
    return (React.createElement(BaseIcon, { className: className, cn: cnMirrorIcon }));
};
